import {
	MyPatientsFilters,
	MyPatientsListFilters,
	MyPatientsListItem,
} from '../../../types/patients'
import { Person } from '../../../types/person'

export interface MyPatientsState {
	list: Array<MyPatientsListItem>
	selectedList: Array<Person>
	count: number
	filters: MyPatientsListFilters
	searchValue: string
	loading: boolean
}

export enum MY_PATIENTS_ACTION_TYPES {
	INIT = 'MY_PATIENTS_INIT',
	GET = 'MY_PATIENTS_GET',
	APPLY_FILTER = 'MY_PATIENTS_APPLY_FILTER',
	SET_SEARCH_VALUE = 'MY_PATIENTS_SET_SEARCH_VALUE',
	SET_LOADING = 'MY_PATIENTS_SET_LOADING',
	SELECT_ONE = 'MY_PATIENTS_SELECT_ONE',
	DESELECT_ONE = 'MY_PATIENTS_DESELECT_ONE',
	SELECT_ALL = 'MY_PATIENTS_SELECT_ALL',
	SELECT_ALL_PAGE = 'MY_PATIENTS_SELECT_ALL_PAGE',
	DESELECT_ALL_PAGE = 'MY_PATIENTS_DESELECT_ALL_PAGE',
	EDIT_PATIENT = 'MY_PATIENTS_EDIT_PATIENT',
	RESET = 'MY_PATIENTS_RESET',
	CLEAR_ALL_FILTERS = 'MY_PATIENTS_CLEAR_ALL_FILTERS',
}

export interface MyPatientsClearAllFiltersAction {
	type: MY_PATIENTS_ACTION_TYPES.CLEAR_ALL_FILTERS
}

export interface MyPatientsResetAction {
	type: MY_PATIENTS_ACTION_TYPES.RESET
}

export interface MyPatientsEditPatientAction {
	type: MY_PATIENTS_ACTION_TYPES.EDIT_PATIENT
	payload: Array<MyPatientsListItem>
}

export interface MyPatientsDeselectAllPageAction {
	type: MY_PATIENTS_ACTION_TYPES.DESELECT_ALL_PAGE
	payload: Array<Person>
}

export interface MyPatientsSelectAllPageAction {
	type: MY_PATIENTS_ACTION_TYPES.SELECT_ALL_PAGE
	payload: Array<Person>
}

export interface MyPatientsSelectAllAction {
	type: MY_PATIENTS_ACTION_TYPES.SELECT_ALL
	payload: Array<Person>
}

export interface MyPatientsSelectOneAction {
	type: MY_PATIENTS_ACTION_TYPES.SELECT_ONE
	payload: Person
}

export interface MyPatientsDeselectOneAction {
	type: MY_PATIENTS_ACTION_TYPES.DESELECT_ONE
	payload: string
}

export interface MyPatientsInitAction {
	type: MY_PATIENTS_ACTION_TYPES.INIT
	payload: { list: Array<MyPatientsListItem>; count: number }
}

export interface MyPatientsGetAction {
	type: MY_PATIENTS_ACTION_TYPES.GET
	payload: { list: Array<MyPatientsListItem>; count: number }
}

export interface MyPatientsSetLoadingAction {
	type: MY_PATIENTS_ACTION_TYPES.SET_LOADING
	payload: boolean
}

export interface MyPatientsApplyMultiFilterAction<T = unknown> {
	type: MY_PATIENTS_ACTION_TYPES.APPLY_FILTER
	payload: {
		key: keyof MyPatientsFilters
		value: T
	}
}

export interface MyPatientsSetSearchValue {
	type: MY_PATIENTS_ACTION_TYPES.SET_SEARCH_VALUE
	payload: string
}

export type MyPatientsAction =
	| MyPatientsInitAction
	| MyPatientsApplyMultiFilterAction
	| MyPatientsSetSearchValue
	| MyPatientsSetLoadingAction
	| MyPatientsGetAction
	| MyPatientsSelectOneAction
	| MyPatientsDeselectOneAction
	| MyPatientsSelectAllAction
	| MyPatientsSelectAllPageAction
	| MyPatientsDeselectAllPageAction
	| MyPatientsEditPatientAction
	| MyPatientsResetAction
	| MyPatientsClearAllFiltersAction
